import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useAuthState } from '@vis-auth/react';
import { AccountType } from 'eve-account-client';
import ManageCompaniesForm from '../components/ManageCompanies/ManageCompaniesForm';
import ManageCompaniesResults from '../components/ManageCompanies/ManageCompaniesResults';
import FullWidthLayout from '../layouts/FullWidthLayout';
import { ManageCompaniesProvider } from '../context/ManageCompanies/ManageCompaniesContext';
import { useAccountQuery } from '../services';

const ManageCompaniesPage = (): JSX.Element => {
  const { user } = useAuthState();
  // eslint-disable-next-line camelcase
  const accountId = user?.account_id as string;
  const { data: accountData } = useAccountQuery(accountId);
  const accountType = accountData?.type || AccountType.CORPORATE;

  const titleText = accountType === AccountType.AGENCY ? 'Client Companies' : 'Company Locations';
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      pageTitle: 'E-Verify - Manage Companies',
    });
  }, []);
  return (
    <FullWidthLayout title={titleText} headerTitle={titleText}>
      <section className="padding-y-4">
        <ManageCompaniesProvider>
          <ManageCompaniesForm />
          <ManageCompaniesResults accountType={accountType} />
        </ManageCompaniesProvider>
      </section>
    </FullWidthLayout>
  );
};

export default ManageCompaniesPage;
